export default __webpack_public_path__ + "static/media/english-icon.44c224af.svg";